import { createStructuredSelector } from 'reselect'

import {
  EVALUATION_STATE_LIST,
  EVALUATION_STATE_LIST_SUCCESS, 
  EVALUATION_STATE_LIST_ERROR,
  EVALUATION_STATE_PAGE_SET,
  EVALUATION_STATE_SEARCH_SET,
  EVALUATION_STATE_SEARCH_CHANGE,
  EVALUATION_STATE_SEARCH_ASSESSMENT_LIST,
  EVALUATION_STATE_SEARCH_ASSESSMENT_LIST_SUCCESS,
  EVALUATION_STATE_SEARCH_ASSESSMENT_LIST_ERROR, 
  EVALUATION_STATE_ADD_SET,
  EVALUATION_STATE_ADD_MODAL_SET,
  EVALUATION_STATE_ADD,
  EVALUATION_STATE_ADD_SUCCESS,
  EVALUATION_STATE_ADD_ERROR,
  EVALUATION_STATE_ADD_CHANGE,
  EVALUATION_STATE_DETAIL,
  EVALUATION_STATE_DETAIL_SUCCESS,
  EVALUATION_STATE_DETAIL_ERROR,
  EVALUATION_STATE_VIEW_MODAL_SET,
  EVALUATION_STATE_EDIT_CHANGE,
  EVALUATION_STATE_EDIT_MODAL_SET,
  EVALUATION_STATE_UPDATE,
  EVALUATION_STATE_UPDATE_SUCCESS,
  EVALUATION_STATE_UPDATE_ERROR,
  EVALUATION_STATE_VIEW_TAB_SET,
  EVALUATION_STATE_UPLOAD_SET,
  EVALUATION_STATE_UPLOAD_SET_SUCCESS,
  EVALUATION_STATE_UPLOAD_SET_ERROR,
  EVALUATION_STATE_UPLOAD_RESET
} from '../../actions';

export const NAME = 'evaluation_state';

export const EvaluationStateList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: EVALUATION_STATE_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const EvaluationStateListSuccess = (data) => ({
  type: EVALUATION_STATE_LIST_SUCCESS,
  payload: data
});

export const EvaluationStateListError = (error) => ({
  type: EVALUATION_STATE_LIST_ERROR,
  payload: error
});

export const EvaluationStatePageSet = (data) => ({
  type: EVALUATION_STATE_PAGE_SET,
  payload: data
});

export const EvaluationStateSearchSet = (data) => ({
  type: EVALUATION_STATE_SEARCH_SET,
  payload: data
});

export const EvaluationStateSearchChangeSet = (data) => ({
  type: EVALUATION_STATE_SEARCH_CHANGE,
  payload: data
});

export const EvaluationStateSearchAssessmentList = (data) => ({
  type: EVALUATION_STATE_SEARCH_ASSESSMENT_LIST,
  payload: data
});

export const EvaluationStateSearchAssessmentListSuccess = (message) => ({
  type: EVALUATION_STATE_SEARCH_ASSESSMENT_LIST_SUCCESS,
  payload: message
});

export const EvaluationStateSearchAssessmentListError = (error) => ({
  type: EVALUATION_STATE_SEARCH_ASSESSMENT_LIST_ERROR,
  payload: error
}); 

export const EvaluationStateAddChangeSet = (data) => ({
  type: EVALUATION_STATE_ADD_CHANGE,
  payload: data
});

export const EvaluationStateAddSet = (data) => ({
  type: EVALUATION_STATE_ADD_SET,
  payload: data
});

export const EvaluationStateAddModalSet = (data) => ({
  type: EVALUATION_STATE_ADD_MODAL_SET,
  payload: data
});

export const EvaluationStateAdd = (data) => ({
  type: EVALUATION_STATE_ADD,
  payload: data
});

export const EvaluationStateAddSuccess = (message) => ({
  type: EVALUATION_STATE_ADD_SUCCESS,
  payload: message
});

export const EvaluationStateAddError = (error) => ({
  type: EVALUATION_STATE_ADD_ERROR,
  payload: error
});

export const EvaluationStateDetail = (data) => ({
  type: EVALUATION_STATE_DETAIL,
  payload: data
});

export const EvaluationStateDetailSuccess = (data) => ({
  type: EVALUATION_STATE_DETAIL_SUCCESS,
  payload: data
});

export const EvaluationStateDetailError = (error) => ({
  type: EVALUATION_STATE_DETAIL_ERROR,
  payload: error
});

export const EvaluationStateViewModalSet = (data) => ({
  type: EVALUATION_STATE_VIEW_MODAL_SET,
  payload: data
});

export const EvaluationStateEditModalSet = (data) => ({
  type: EVALUATION_STATE_EDIT_MODAL_SET,
  payload: data
});

export const EvaluationStateEditChangeSet = (data) => ({
  type: EVALUATION_STATE_EDIT_CHANGE,
  payload: data
});

export const EvaluationStateUpdate = (data) => ({
  type: EVALUATION_STATE_UPDATE,
  payload: data
});

export const EvaluationStateUpdateSuccess = (message) => ({
  type: EVALUATION_STATE_UPDATE_SUCCESS,
  payload: message.message
});

export const EvaluationStateUpdateError = (error) => ({
  type: EVALUATION_STATE_UPDATE_ERROR,
  payload: error
});

export const EvaluationStateViewTabSet = (data) => ({
  type: EVALUATION_STATE_VIEW_TAB_SET,
  payload: data
});

export const EvaluationStateUploadSet = (file) => ({
  type: EVALUATION_STATE_UPLOAD_SET,
  payload: { file },
});

export const EvaluationStateUploadSetSuccess = (items) => ({
  type: EVALUATION_STATE_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const EvaluationStateUploadSetError = (error) => ({
  type: EVALUATION_STATE_UPLOAD_SET_ERROR,
  payload: error,
});

export const EvaluationStateUploadReset= () => ({
  type: EVALUATION_STATE_UPLOAD_RESET
});

const evaluation_state = (state) => state[NAME];

export const EvaluationStateSelector = createStructuredSelector({
  evaluation_state
})
 